module.exports = __webpack_public_path__ + "img/banner3.e669a4b6.png";